import { useContext, useState } from 'react';
import { getAllIds, mainSearch, recodeNow } from '../components/indexDB/indexDBStora';
import { config } from '../context/config';
import { intialData } from '../context/initial';

const GET_TABLE = {
    products: "product",
};

export const useRestore = () => {
    const { api } = useContext(config);
    const { initialProductState } = useContext(intialData);

    const [restoredProducts, setRestoredProducts] = useState([]);


    const checkSecondaryTables = async (tableName, data, key) => {
        const VALID_TABLES = new Set(["categories", "warehouse"]);
        if (!tableName ||!data ||!key ||!VALID_TABLES.has(tableName)) {
            return false;
        }
        const value = data[key];
        
        if (value == null) {
            return false;
        }
        
        const exists = await mainSearch(tableName, value);
        if (exists) {
            return true;
        }


        await recodeNow(
            {
                ...data,
                ...(tableName === "warehouse" && {box: []})
            },
            tableName
        );
        return true;
    }

    const restore = async () => {
        const allRestored = [];

        await Promise.all(
            Object.keys(GET_TABLE).map(async (eachTable) => {
                const ids = await getAllIds(eachTable);

                const MAX_DATA = 2;
                const DELAY = 250;

                const countRes = await fetch(
                    `${api}/${GET_TABLE[eachTable]}/count`,
                    {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ ids })
                    }
                );

                const result = await countRes.json();

                if (!result.status) return;

                let hasMore = true;
                let page = 0;

                while (hasMore) {
                    const response = await fetch(
                        `${api}/${GET_TABLE[eachTable]}/restore/${MAX_DATA}?page=${page}`,
                        {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ ids })
                        }
                    );

                    const result = await response.json();

                    for (const product of result.data) {
                        const meta = product.meta;
                        const emp = meta?.creator?.nameEmp?.split("#") || ["", ""];
                        const dates = meta?.dates || {};
                        const price = product.price || {};
                        const measure = product.measuring_unit || {};
                        const tax = product.tax || {};

                        // check secondary tables of product 
                        await Promise.all([
                            checkSecondaryTables("categories", product.nameCategory, "id"),
                            checkSecondaryTables("warehouse", product.investory, "id")
                        ]);

                        const newProduct = {
                            ...initialProductState,
                            id: {
                                ...initialProductState.id,
                                emp: {
                                    name: emp[0] || "",
                                    id: emp[1] || "",
                                }
                            },

                            meta: {
                                ...initialProductState.meta,
                                barcode: meta?.barcode || "",
                                createdAt: dates?.createdAt || "",
                                expiredDate: dates?.expired || "",
                                updateDate: dates?.updateAt || "",
                            },

                            nameProudct: product.productName || "",
                            sku: product.SKU || "",
                            brand: product.brand || "",

                            price: {
                                ...initialProductState.price,
                                befPrice: String(price?.bef) || "0",
                                aftprice: String(price?.aft) || "0",
                            },

                            discount: {
                                ...initialProductState.discount,
                                discountType: price?.disc?.type || "",
                                discountValue: price?.disc?.value || 0,
                            },

                            measureUnit: {
                                ...initialProductState.measureUnit,
                                type: measure?.type || "",
                                value: measure?.value || 0,
                            },

                            category: product.nameCategory,
                            
                            investory: product.investory,

                            tax: {
                                ...initialProductState.tax,
                                taxType: tax?.tax_type || "",
                                taxValue: tax?.tax_value || 0,
                            },

                            async: {
                                ...initialProductState.async,
                                status: "t",
                                reason: "new"
                            }
                        };


                        allRestored.push({
                            tableName: eachTable,
                            data: newProduct
                        });
                    }

                    hasMore = result.hasMore;
                    page++;

                    await new Promise((res) => setTimeout(res, DELAY));
                }
            })
        );
        setRestoredProducts(allRestored);
        await Promise.all(
            allRestored.map(restoredProduct => recodeNow(restoredProduct.data, restoredProduct.tableName))
        );
        // 👇 save to IndexedDB once
    };

    return {restore, restoredProducts}
};